import { render } from "./RejectSourcing.vue?vue&type=template&id=9a7522c4"
import script from "./RejectSourcing.vue?vue&type=script&lang=js"
export * from "./RejectSourcing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__